import React from "react";
import moment from "moment";

import PlaceholderIMG from "../../sharedComponents/placeholderImage";
import FilterPanel from "../../sharedComponents/filterPanel";

const BadgeDetails = ({ badgeDetails, memberBadges, show = true, toggle }) => {
	const renderDetails = () => {
		const { badge_count, description, image, name } = badgeDetails;

		return (
			<div className="text-center">
				<PlaceholderIMG width="200" height="200" src={image} objectFit="contain" />
				<h3 className="text-primary-dark">{name}</h3>
				<div className="bold px-5 mb-2">{description}</div>
				<div className="text-primary-dark">Total Badges: {badge_count}</div>
			</div>
		);
	};

	const renderMemberBadges = () => {
		return memberBadges && memberBadges.results
			? memberBadges.results.map((item) => {
				return item.date_range && item.date_range.length ? (
					<div key={item.id} className="d-flex card card-light p-3 border-0 mt-3 flex-row ">
						<div className={`flex-fill ${item.date_range[1] ? "" : "text-center"}`}>
							<div className="bold">{moment(item.date_range[0]).format("LL")}</div>
							<div className="text-secondary">
								{item.date_range[1] ? "Start Date" : "Achievement Date"}
							</div>
						</div>
						{item.date_range[1] && (
							<div className="flex-fill text-right">
								<div className="bold">{moment(item.date_range[1]).format("LL")}</div>
								<div className="text-secondary">End Date</div>
							</div>
						)}
					</div>
				) : null;
			})
			: null;
	};

	return (
		<FilterPanel show={show} title="Badge Details" className="hide-sub-header" toggle={() => toggle(false)} closeBtn>
			<div className="container">
				{renderDetails()}
				{renderMemberBadges()}
			</div>
		</FilterPanel>
	);
};

export default BadgeDetails;
